<script>
import { hmdaMethods, toasterMethods } from '@state/helpers'

export default {
  props: {
    projectId: { type: [String, Number], default: () => '' },
    activities: { type: Array, default: () => [] },
  },
  data() {
    return {
      activitiesList: [],
      options: [25, 50, 75, 100],
      fields: [
        {
          key: 'date',
          label: 'Date',
          sortable: false,
          class: 'text-left',
        },
        {
          key: 'activity',
          label: 'Activity',
          sortable: false,
          class: 'text-left',
        },
        {
          key: 'userName',
          label: 'User',
          sortable: false,
          class: 'text-left',
        },
      ],
      rows: 0,
      perPage: 25,
      currentPage: 1,
      showSpinner: false,
    }
  },

  mounted() {
    this.getActivityLogs()
  },

  methods: {
    ...hmdaMethods,
    ...toasterMethods,

    async getActivityLogs() {
      this.showSpinner = true
      this.fetchActivityLogs({
        ProjectId: this.projectId,
        PageSize: this.perPage,
        PageNumber: this.currentPage,
      })
        .then((response) => {
          this.activitiesList = response
            ? response.data.projectSummaryList || []
            : []
          this.rows = response.data.totalProjectSummaryCount
          this.currentPage = this.currentPage
          this.showSpinner = false
        })
        .catch(() => {
          this.showSpinner = false
        })
    },

    paginationEvent(currentPage) {
      if (this.currentPage !== currentPage) {
        this.showSpinner = true
        this.currentPage = currentPage
        this.getActivityLogs()
      }
    },

    rowPerPageCount(pageValue) {
      this.perPage = parseInt(pageValue)
      this.currentPage = 1
      if (this.rows !== 0) {
        this.showSpinner = true
        this.getActivityLogs()
      }
    },
  },
}
</script>

<template>
  <div>
    <BaseSpinner v-if="showSpinner" />

    <h4>Activity Logs</h4>

    <BaseDataTable
      ref="table"
      heade-title=""
      :options="options"
      :items="activitiesList"
      :fields="fields"
      showdatatablefooter
      :total-rows="rows"
      :per-page="perPage"
      :current-page="currentPage"
      @rowPerPageChange="rowPerPageCount"
      @paginationEvent="paginationEvent"
    />
  </div>
</template>
